import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { SessionService } from './services/session.service';
import { IdleService } from './services/idle.service';
import { PhiSecurityService } from './services/phi-security.service';
import { FilterService } from './services/filter.service';
import { PhiTimerService } from './services/phi-timer.service';
import { UserActivityService } from './services/useractivity.service';
import { Subscription } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DataService } from './services/data.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  lastActivityTimestamp: number = 0;
  debounceTimeout: any;
  private phiSubscription?: Subscription;
  reqSubcription: Subscription[] = []
  constructor(
    private sessionService: SessionService,
    private idleService: IdleService,
    private phiSecurityService: PhiSecurityService,
    private filterService: FilterService,
    private dataService: DataService,
    // private phiTimerService: PhiTimerService,
    private userActivityService: UserActivityService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // PHI access check only on brand selection/load
    this.reqSubcription.push(
      this.filterService.phiEventTrigger.subscribe((res: any) => {
        this.filterService.hasPhiHiddenToggle = false;
        if(res && res.phi && res.selectedOption) {
          this.getPhiUserAccess(res.selectedOption);
        } else {
          this.phiSecurityService.setVerified(false);
          this.phiSecurityService.removePHIWarningOverlay();
          this.phiSecurityService.disableRestrictions();
        }
      })
    );
    
    // Subscribe to PHI toggle changes
    // this.phiSubscription = this.filterService.isPHIFunc.subscribe(
    //   (phiEnabled: boolean) => {
    //     // Keep the global state in sync
    //     this.filterService.phiChecked = phiEnabled;

    //     if (phiEnabled) {
    //       this.phiSecurityService.enableRestrictions();
    //     } else {
    //       this.phiSecurityService.disableRestrictions();
    //     }
    //   },
    // );

    // Check initial PHI state
    // if (this.filterService.phiChecked) {
    //   this.phiSecurityService.enableRestrictions();
    // }

    // Disable PHI security when navigating away from the current page
    // this.router.events.pipe(
    //   filter(event => event instanceof NavigationStart)
    // ).subscribe(() => {
      // this.filterService.phiChecked = false;
      // this.userActivityService.setData({ PHI: 'no' });
      // this.filterService.isPHIFunc.next(false);
      // this.phiSecurityService.disableRestrictions();
      // this.phiTimerService.stopTimer();
    // });
  }

  getPhiUserAccess(data:any) {
    this.phiSubscription?.unsubscribe();
    if(this.filterService.isEmptyObject(data) == false) {
      let obj = Object.assign({}, data, {'user_id': this.sessionService.getUsername()})
      this.phiSubscription = this.dataService.getPhiUserAccess(obj).subscribe((res:any) => {
        if(res && res?.phi_access) {
          this.filterService.hasPhiHiddenToggle = res.phi_access;
          this.filterService.phiAccessConsentFlag = res?.phi_phi_access_consent_flag || res?.phi_access_consent_flag || 'N';

          // // Show PHI warning overlay if PHI was enabled (persists across refresh)
          // sessionStorage.getItem('phiLogged')

          if(sessionStorage.getItem('phiLogged') && this.filterService.hasPhiHiddenToggle) {
            this.filterService.phiChecked = true;
            this.phiSecurityService.setVerified(true);
            this.phiSecurityService.showPHIWarningOverlay();
            this.phiSecurityService.enableRestrictions();
          }
        } else {
          this.phiSecurityService.setVerified(false);
          this.phiSecurityService.removePHIWarningOverlay();
          this.phiSecurityService.disableRestrictions();
        }
      }, err => {
        this.phiSecurityService.setVerified(false);
        this.phiSecurityService.removePHIWarningOverlay();
        this.phiSecurityService.disableRestrictions();
      });
    }
  }

  ngOnDestroy(): void {
    if (this.phiSubscription) {
      this.phiSubscription.unsubscribe();
    }
    this.reqSubcription.forEach(res => res.unsubscribe());
    // Clean up subscriptions
    // Ensure security restrictions are disabled on component destroy
    // this.phiSecurityService.disableRestrictions();
  }

  // @HostListener('document:mousemove')
  // @HostListener('document:keydown')
  // handleUserActivity() {
  //   this.authService.resetInactivityTimer();
  // }

  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:keydown', ['$event'])
  handleUserActivity(event: MouseEvent | KeyboardEvent) {
    if (this.sessionService.getUsername()) {
      // Reset the debounce timeout
      clearTimeout(this.debounceTimeout);

      // Set a new debounce timeout
      this.debounceTimeout = setTimeout(() => {
        this.lastActivityTimestamp = Date.now();
        this.idleService.checkForInactivity();
      }, 1000); // Adjust the debounce time as needed
    }
  }
}
